import React, { useEffect, useMemo, useRef, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { setConfigLoading } from "redux/configurationReducer";
// import { config } from "assets/common/dynamicConfig";
import Layout from "components/Layout";
import DynamicForm from "components/DynamicForm";

import {
  updateWorkflowInfo,
  updateApplicantStatusAndSubWorkflowStatus,
  getWorkflowData
} from "api/formDisplay";
import { getConfiguration } from "api/configuration";

import {
  changeActiveGroup,
  changeMaxActiveSection,
  changeActiveSection,
  setPrimaryUser,
  changeMaxActiveGroup,
  setworkflowUser,
} from "redux/userInfo";
import {
  clearSelectedData,
  clearValidateTriggered,
  setIsToggled,
  setRestrictedView,
  setSelectedData,
} from "redux/formDisplay";
import {
  setShowDataPreview,
  clearSaveData,
  setRecursiveFormData,
  setShowRecursiveForm,
  clearShowData,
  setShowAddMore,
  clearRecursiveFormData,
  setIsEditRecursiveForm,
  setRecursiveActions,
  setAddSaveData,
  clearRecursiveFormDataKey,
  setIsSignerRecursion,
  cleardeleteRecursiveDocument,
  clearSignerParams,
  setShowData,
  setFormFields,
  setArrayName,
} from "redux/recursiveReducer";
import { createUserWorkflowPayload } from "helper/createPayload";
import { dynamicFormScroll, dynamicFormScrollBottom } from "utils";
import { Group } from "lib";
import FormButton from "components/FormButton";
import { validate } from "components/DynamicForm/validate";

import {
  setBanner,
  setFormOccupancy,
  setNavOrientation,
  setSections,
  setStepperDisplay,
} from "redux/stepperReducer";

import LoadingSpinner from "lib/LoadingSpinner";
import { getAllSignerId, autoFillData } from "helper";
import {
  cleardeleteDocument,
  setdeleteDocument,
} from "redux/uploadDocumentReducer";
import { handlePayment } from "constants/payment";
import {
  setIsPaymentInProgess,
  setIsPaymentInitiationError,
  setMaxAmountExceeded,
} from "redux/paymentReducer";
import {
  getPaymentAndUserInfo,
  sendPaymentLinkThroughMails,
  updateFullPaymentDataThroughRequestchange,
  updateOfflineMicroServiceFullPayment,
  updateOfflineMicroServicePartialPayment,
  updatePartialPaymentDataThroughRequestchange,
} from "api/payment";
import PaymentRecursive from "components/PaymentRecursive";
import { clearFieldRecursionData } from "redux/fieldRecursiveReducer";
import { getOrgInfo } from "api/organisation";
import { setLogoUrl } from "redux/urlEncryption";
import { encryptURLParams } from "api/UrlEncryption";
import { setRequestedDocs } from "redux/requestedDocReducer";
import SendPaymentLinkModal from "components/SendPaymentLinkModal";

const Payment = (props) => {
  const dispatch = useDispatch();
  const params = useParams();
  const navigate = useNavigate();
  const activeGroup = useSelector((state) => state.userInfo.activeGroup);
  const activeSection = useSelector((state) => state.userInfo.activeSection);
  const maxActiveSection = useSelector(
    (state) => state.userInfo.maxActiveSection
  );

  const [showSendPaymentLinkModal, setShowSendPaymentLinkModal] =
    useState(false);
  const [requestChangeConfig, setRequestChangeConfig] = useState({});
  const [sendingPaymentLink, setSendingPaymentLink] = useState(false)

  const config = useSelector((state) => state.configurationReducer?.config);
  const organisation_id = useSelector(
    (state) => state.configurationReducer?.config?.organisation_id
  );

  const [isUpdatingPayment, setIsUpdatingPayment] = useState(false);
  const [showPaymentProcessingNotice, setPaymentProcessingNotice] = useState(false)
  const maxActiveGroup = useSelector((state) => state.userInfo.maxActiveGroup);
  const selectedData = useSelector((state) => state.formData?.selectedData);

  const savedFormData = useSelector(
    (state) => state?.fieldRecursiveReducer?.saveData
  );
  const fieldRecursiveName = useSelector(
    (state) => state?.fieldRecursiveReducer?.fieldRecursiveName
  );
  const selectedQuestion = useSelector(
    (state) => state.formData?.selectedQuestion
  );
  const stepperSections = useSelector(
    (state) => state?.stepperReducer?.sections
  );
  const dataPreview = useSelector((state) => state.recursive?.showDataPreview);
  const saveData = useSelector((state) => state.recursive?.saveData);
  const configLoader = useSelector(
    (state) => state.configurationReducer?.loading
  );
  const workflowLoader = useSelector((state) => state.formData?.loading);

  const uploadedDocument = useSelector(
    (state) => state.uploadDocumentReducer?.uploadedDocument
  );
  const evaluationRule = useSelector((state) => state.formData?.evaluationRule);
  const primaryUser = useSelector((state) => state.userInfo?.primaryUser);
  const workflowUser = useSelector((state) => state.userInfo?.workflowUser);
  const userDetail = useSelector((state) => state.userInfo?.userDetail);
  const recursiveFormData = useSelector(
    (state) => state.recursive?.recursiveFormData
  );
  const loggedInUserInfo = useSelector(
    (state) => state.loggedInUserInfo?.userAuthInfo
  );

  const arrayName = useSelector((state) => state?.recursive?.arrayName);
  const showRecursiveForm = useSelector(
    (state) => state.recursive.showRecursiveForm
  );

  const dynamic_wf = config?.dynamic_wf;
  const recursive = useSelector((state) => state.recursive);
  const questionData = useSelector((state) => state.formData?.questionData);
  const questionnaireId = useSelector(
    (state) => state.formData?.questionnaireId
  );

  const isSignerRecursion = useSelector(
    (state) => state.recursive?.isSignerRecursion
  );
  const requestedDocs = useSelector(
    (state) => state?.requestedDocReducer?.requestedDocs
  );
  const userInfoUpdatedSuccessfully = useSelector(
    (state) => state?.formData?.userInfoUpdatedSuccessfully
  );

  const documents = useSelector(
    (state) => state?.uploadDocumentReducer?.documents
  );
  const deleteDocument = useSelector(
    (state) => state?.uploadDocumentReducer?.deleteDocument
  );
  const deleteRecursiveDocument = useSelector(
    (state) => state.recursive?.deleteRecursiveDocument
  );
  const blockSection = useSelector((state) => state?.userInfo?.activeSection);
  const blockGroup = useSelector((state) => state?.userInfo?.activeGroup);
  const decryptedId = useSelector((state) => state?.urlEncryption?.urlId);
  const wfJourney = useSelector(
    (state) => state?.configurationReducer?.config?.wf_journey
  );
  const staticData = useSelector((state) => state.staticData);
  const status = useSelector((state) => state.staticData?.status);
  const paymentLoader = useSelector(
    (state) => state?.paymentReducer?.fetchingPaymentDetails
  );
  const paymentInfo = useSelector((state) => state.paymentReducer);
  const paymentDetails = useSelector(
    (state) => state?.paymentReducer?.payment_details
  );

  const disablePartial = useSelector(
    (state) => state?.paymentReducer?.payment_details?.disable_partial
  );

  const isOnlinePaymentInitiated = useSelector(
    (state) => state?.paymentReducer?.isOnlinePaymentInitiated
  );

  const search = window.location.search;
  const query = new URLSearchParams(search);
  const requestedId = React.useMemo(() => {
    //optimization
    return query.get("requestedId");
  }, [search, query]);

  const transaction_id = useMemo(() => {
    return query.get("transaction_id");
  }, [search, query]);

  const identifier = useMemo(() => {
    return query.get("identifier");
  }, [search, query]);

  let formStructure = {},
    sections = {},
    fields,
    banner;
  const [formErr, setFormErr] = useState({});

  //Mobile responsiveness state
  const [isMobile, setIsMobile] = useState(false);
  const stateErrRef = useRef();
  const selectedDataRef = useRef();
  stateErrRef.current = { ...formErr };
  selectedDataRef.current = { ...selectedData };
  let loggedUserId = loggedInUserInfo?.profileInfo?.userId || null;

  const sectionFields = [];
  wfJourney?.map((item) => {
    if (item?.module_name == "payment_form") {
      item?.form_structure?.sections?.map((ele) => {
        if (ele.order == blockSection) {
          ele?.form_groups?.map((group) => {
            if (group.order == blockGroup) {
              const formElement = group.form_elements;

              formElement?.map((data) => {
                if (data.type == "recursive") {
                  let name = data.name;
                  let label = data.title;

                  sectionFields.push({ name, label });
                } else if (data.input_fields) {
                  data.input_fields?.map((data) => {
                    let name = data.name;
                    let label = data.label;
                    sectionFields.push({ name, label });
                  });
                } else {
                  let name = data.name;
                  let label = data.label;
                  sectionFields.push({ name, label });
                }
              });
            }
          });
        }
      });
    }
  });

  const IndirectEval = (evalString) => {
    return eval(evalString);
  };

  const handleBack = () => {
    if (dataPreview) {
      dispatch(setShowAddMore(false));
      dispatch(setShowDataPreview(false));
      dispatch(clearSaveData());
      dispatch(clearShowData());
    }
    if (activeGroup == 1) {
      if (activeSection == 1) return;
      let lastSection = getPreviousSection(
        formStructure?.sections?.slice()?.reverse()
      );
      dispatch(changeActiveSection(lastSection));
      let lastGroup = getPreviousGroup(
        sections[lastSection]?.form_groups?.slice()?.reverse()
      );
      dispatch(changeActiveGroup(lastGroup));
      dispatch(changeMaxActiveSection(lastSection));
      dispatch(changeMaxActiveGroup(lastGroup));
    } else {
      dispatch(
        changeActiveGroup(
          getLastGroup(sections[activeSection]?.form_groups?.slice()?.reverse())
        )
      );
      dispatch(changeMaxActiveGroup(activeGroup - 1));
      dynamicFormScroll();
    }
    setFormErr({});
  };

  const getPreviousGroup = (groupArray) => {
    for (const group of groupArray) {
      if (IndirectEval(group.show) === true) return group?.group_order;
    }
  };

  const getLastGroup = (groupArray) => {
    for (const group of groupArray) {
      if (IndirectEval(group.show) === true && group.group_order < activeGroup)
        return group?.group_order;
    }
  };

  const getPreviousSection = (sectionArray) => {
    for (const section of sectionArray) {
      if (IndirectEval(section.show) === true && section.order < activeSection)
        return section?.order;
    }
  };

  // const handleSkip = () => {}

  useEffect(() => {
    const fetchingPaymentDetails = async () => {
      if (decryptedId?.paymentTransactionId && decryptedId?.userId) {
        dispatch(setIsPaymentInProgess(true));
        dispatch(setIsPaymentInitiationError(false));
        dispatch(changeActiveGroup(1));
        dispatch(changeActiveSection(1));
        dispatch(changeMaxActiveSection(1));
        dispatch(changeMaxActiveGroup(1));
        dispatch(clearSelectedData());
        const paymentInfo = await dispatch(
          getPaymentAndUserInfo({
            payment_id: decryptedId?.paymentTransactionId,
            user_id: decryptedId?.userId,
          })
        ).unwrap();

        if (paymentInfo?.pending_amount == 0 && !transaction_id) {
          console.log("filteredWFDataBasedOnModule.module_settings",config);
          setIsUpdatingPayment(true);
          const stateData = {
            header: config?.module_settings?.payment_completed_header || "Payment Completed",
            content:
              config?.module_settings?.payment_completed_content ||
              "You do not have any pending amount to pay. As you've already paid the amount.",
            buttonText: config?.module_settings?.payment_completed_button_text || "Done",
            organisation_id: organisation_id,
            isPaymentSuccess: true,
          };

          const urlParams = {
            encryptedUserID: decryptedId?.userId,
            encryptedPaymentTransactionId: decryptedId?.paymentTransactionId,
          };

          await handlePaymentResult(
            true,
            stateData,
            urlParams,
            "/payment-success"
          );
          setIsUpdatingPayment(false);
        }
        if (paymentInfo?.configuration_id)
          dispatch(getConfiguration(paymentInfo?.configuration_id));
      }
    };
    if (decryptedId?.paymentTransactionId) {
      fetchingPaymentDetails();
    }
  }, [decryptedId?.paymentTransactionId, decryptedId?.userId]);

  useEffect(() => {
    const reRouteToDisplayUpdationStatus = async (result) => {
      const stateData = {
        header: "Update Successful!",
        content:
          "Dear User, the requested changes have already been implemented.",
        buttonText: "Done",
        organisation_id: organisation_id,
        isPaymentSuccess: result,
      };

      const urlParams = {
        encryptedUserID: decryptedId?.userId,
        encryptedPaymentTransactionId: decryptedId?.paymentTransactionId,
      };

      await handlePaymentResult(true, stateData, urlParams, "/payment-success");
    };

    if (
      transaction_id &&
      paymentDetails &&
      paymentDetails?.requestChange &&
      Object.keys(paymentDetails?.requestChange).length
    ) {
      let requestChangesArray = paymentDetails?.requestChange
        ? [...paymentDetails.requestChange].reverse()
        : [];

      const matchedReqChangeObject = requestChangesArray?.find(
        (item) => item?.transaction_id == transaction_id
      );

      if (!matchedReqChangeObject) return null;

      if (
        !matchedReqChangeObject?.is_active &&
        matchedReqChangeObject?.is_addressed
      ) {
        reRouteToDisplayUpdationStatus(true);
      }

      dispatch(changeActiveGroup(matchedReqChangeObject?.active_group));
      dispatch(changeActiveSection(matchedReqChangeObject?.active_section));
      const data = {
        active_section: matchedReqChangeObject?.active_section,
        active_group: matchedReqChangeObject?.active_group,
        comment: matchedReqChangeObject?.comment,
        updateRequestedFields: matchedReqChangeObject?.requestedDocs,
        updateRequestedAt: matchedReqChangeObject?.updatedAt,
        updateRequestedBy: matchedReqChangeObject?.updatedBy,
        requestedId: transaction_id,
        requestedFlow: matchedReqChangeObject?.requestedFlow,
        is_active: matchedReqChangeObject?.is_active,
        is_addressed: matchedReqChangeObject?.is_addressed,
      };

      const reqDocObject = {
        data,
      };

      dispatch(setRequestedDocs(reqDocObject));
    }
  }, [paymentDetails, transaction_id]);

  // Role based control for different users from here
  useEffect(() => {
    let userId = JSON.parse(localStorage.getItem("userToken"));
    if (userId && userDetail?.created_by ) {
      if (userId?.userId != userDetail?.source_data?.internal_poc_user_id) {
        navigate("/error");
      }
    }
  }, [userDetail]);

  // Mobile Responsivess - conditions - start
  const checkWindowWidth = () => {
    const width = window.innerWidth;
    if (width < 640 && !isMobile) {
      setIsMobile(true);
    } else if (width > 640 && isMobile) {
      setIsMobile(false);
    }
  };

  useEffect(() => {
    if (
      paymentDetails?.user_data?.offline_full_payment &&
      Object.keys(paymentDetails?.user_data?.offline_full_payment).length
    ) {
      let offlinePaymentData = paymentDetails?.user_data?.offline_full_payment;
      let offlinePaymentDataKeys = Object.keys(offlinePaymentData);

      offlinePaymentDataKeys.map((item) => {
        dispatch(
          setSelectedData({ key: item, value: offlinePaymentData?.[item] })
        );
        setFormErr({ key: item, value: "" });
      });
    }
  }, [paymentDetails]);

  window.addEventListener("resize", () => checkWindowWidth());

  useEffect(() => {
    checkWindowWidth();
  }, []);

  config?.wf_journey?.map((item) => {
    let activeStepOrder = 1;
    if (item?.step === activeStepOrder) {
      formStructure = { ...item?.form_structure };
    }
    return;
  });

  banner = formStructure?.sections?.filter((item) => item?.type === "banner");
  formStructure?.sections?.forEach((item, index) => {
    sections[item?.order] = {
      title: item?.title,
      show_form_stepper: item?.show_form_stepper,
      form_groups: item?.form_groups?.map((_item, _index) => {
        return {
          name: _item?.name,
          title: _item?.title,
          group_order: _item?.order,
          display_group: _item?.show,
          group_length: item?.form_groups?.length,
          show: item?.show,
          form_elements: _item?.form_elements,
          form_buttons: _item?.form_buttons,
        };
      }),
      section_order: item?.order,
      restricted_view: item?.restricted_view ? item?.restricted_view : false,
      element_number: index,
      display_section: item?.show,
    };
  });

  useEffect(() => {
    dispatch(setSections(sections));
    dispatch(setBanner(banner));
    dispatch(setFormOccupancy(formStructure.form_occupancy));
    dispatch(setNavOrientation(formStructure.nav_orientation));
    if (formStructure.layout === "regular") dispatch(setStepperDisplay(false));
    else dispatch(setStepperDisplay(true));
  }, [config]);

  const handleCancel = () => {
    dispatch(setShowAddMore(true));
    dispatch(setMaxAmountExceeded(false));
    showRecursiveForm && dispatch(setShowRecursiveForm(false));
    !showRecursiveForm && dispatch(clearRecursiveFormData());
    dispatch(setIsEditRecursiveForm(false));
    dispatch(cleardeleteRecursiveDocument());
    setFormErr({});
    dispatch(clearValidateTriggered());
    dynamicFormScroll();
  };

  const handleAdd = () => {
    let formattedFormFields = fields?.filter(
      (item) => item.type != "paymentNote"
    );

    Object.keys(fields)?.length &&
      Object.keys(fields).map((key) => {
        if (fields[key].type != "paymentNote") {
          return fields[key];
        }
      });

    formattedFormFields = formattedFormFields.filter((item) => item);
    fields = formattedFormFields;

    formattedFormFields = fields[0].input_fields.filter(
      (item) => item.type != "toggle"
    );
    dispatch(setFormFields(formattedFormFields));
    dispatch(setRecursiveActions(fields[0]?.recursive_actions));

    let setShowRecursiveData = {},
      saveRecursiveData = {};

    formattedFormFields?.map((item, index) => {
      if (recursiveFormData[item.name] && IndirectEval(item?.show)) {
        saveRecursiveData[item.name] = recursiveFormData[item?.name];
        setShowRecursiveData[item.name] = recursiveFormData[item?.name];
      }
      if (recursiveFormData?.hasOwnProperty("verification_response")) {
        saveRecursiveData["verification_response"] =
          recursiveFormData["verification_response"];
        dispatch(clearRecursiveFormDataKey({ key: "verification_response" }));
      }
    });

    if (deleteRecursiveDocument) {
      deleteRecursiveDocument?.map((ele) => {
        dispatch(setdeleteDocument({ key: "", value: ele }));
      });
      dispatch(cleardeleteRecursiveDocument());
    }
    let recursiveNameFields = [];
    fields[0].input_fields.map((item) => {
      if (item.type == "toggle") return;
      return recursiveNameFields.push({ name: item.name, label: item.label });
    });

    recursiveNameFields.map((item) => {
      dispatch(clearRecursiveFormDataKey({ key: item.name }));
    });

    dispatch(setShowData(setShowRecursiveData));
    dispatch(setAddSaveData(saveRecursiveData));
    dispatch(setShowRecursiveForm(false));
    dispatch(setShowAddMore(true));
    dispatch(setShowDataPreview(true));
  };

  const getValidateFields = () => {
    return fields?.reduce((acc, item) => {
      if (["group", "recursive", "paymentRecursive"].includes(item.type)) {
        const visibleFields =
          item.input_fields?.filter(
            (_item) => !_item.hasOwnProperty("show") || IndirectEval(_item.show)
          ) || [];
        return [...acc, ...visibleFields];
      } else if (!item.hasOwnProperty("show") || IndirectEval(item.show)) {
        return [...acc, item];
      }
      return acc;
    }, []);
  };

  const getErrors = async(validateFields, isRecursive) => {
    if (isRecursive) {
      return  await validate(
        validateFields,
        recursiveFormData,
        dispatch,
        staticData,
        null,
        recursive
      );
    } else if (dataPreview && !showRecursiveForm) {
      return {};
    } else {
      return  await validate(
        validateFields,
        selectedData,
        dispatch,
        staticData,
        workflowUser
      );
    }
  };

  const getPayload = (formattedData) => {
    if (saveData?.length) {
      let recursiveData = { [arrayName]: saveData };
      let signer_data = isSignerRecursion
        ? getAllSignerId(config?.wf_journey[0]?.form_structure?.sections)
        : [];
      return createUserWorkflowPayload(
        formattedData,
        recursiveData,
        uploadedDocument,
        selectedQuestion,
        questionData,
        questionnaireId,
        isSignerRecursion,
        signer_data,
        documents,
        deleteDocument,
        evaluationRule
      );
    } else {
      return createUserWorkflowPayload(
        formattedData,
        null,
        uploadedDocument,
        selectedQuestion,
        questionData,
        questionnaireId,
        null,
        null,
        documents,
        deleteDocument,
        evaluationRule
      );
    }
  };

  const validateAndSubmit = async (
    action,
    extraParams
  ) => {
    const validateFields = getValidateFields();
    const errors = getErrors(validateFields, extraParams?.isRecursive);
    const formattedData = { ...selectedData };
    const payload = getPayload(formattedData);
    let additional_info = {}
    let workflowInfo = await getWorkflowData(paymentDetails?.user_data?.primaryWorkflowId)

    if (config?.gateway_provider === 'billdesk') {
      const { source_data } = workflowInfo || {};

      let additional_info3 = "NA";
      if (source_data?.region_name && source_data?.sbu_name) {
        additional_info3 = `${source_data.region_name}_${source_data.sbu_name}`;
      } else if (source_data?.region_name) {
        additional_info3 = source_data.region_name;
      } else if (source_data?.sbu_name) {
        additional_info3 = source_data.sbu_name;
      }
      
      let additional_info6 = "NA";
      if (source_data?.taluka_pincode && source_data?.state_name) {
        additional_info6 = `${source_data.taluka_pincode}_${source_data.state_name}`;
      } else if (source_data?.taluka_pincode) {
        additional_info6 = source_data.taluka_pincode;
      } else if (source_data?.state_name) {
        additional_info6 = source_data.state_name;
      }
      
    additional_info = {
        additional_info1: source_data?.gst_number || "NA",
        additional_info2: source_data?.territory || "NA",
        additional_info3,
        additional_info4: source_data?.division || "NA",
        additional_info5: "NA",
        additional_info6,
      };
      
    }
    const formattedpayload = payload
      ? {
          ...payload,
          userId: decryptedId?.userId,
          user_initiated_flow: true,     //Changed Key isRMFlow to user_initiated_flow
          requestedId: requestedId,
        }
      : null;

    if (!Object.keys(errors).length) {
      switch (action) {
        case "add":
          handleAdd();
          break;
        case "next":
          handleNext();
          break;
        case "payment":
          const filteredWFDataBasedOnModule = wfJourney?.find(item => item?.module_name === 'payment_form');
          handlePayment({
            dispatch,
            selectedPaymentMethod: extraParams?.payment_gateway,
            selectedData: { ...selectedData, ...workflowUser },
            paymentDetails,
            additional_info,
            selectedPaymentMethod: config?.gateway_provider || 'razorpay',
            org_identifier : config?.org_identifier || '',
            paymentConfig:config,
            payment_settings:filteredWFDataBasedOnModule.module_settings,
            payment_content: extraParams?.status_to_update,
            handlePaymentResult,
            organisation_id,
            decryptedId,
            navigate,
            verifyPaymentStatusAndProceed
          });
          break;
        case "offlinePayment":
          handleOfflinePayment(formattedData, selectedData, extraParams?.isRecursive);
          break;
        case "offlinePartialPayment":
          handleOfflinePartialPayment();
          break;
        case "offlinePartialPaymentUpdate":
          handleUpdatePartialPaymentViaRequestChanges();
          break;
        case "offlineFullPaymentUpdate":
          handleUpdateFullPaymentViaRequestChanges();
          break;
        case "sendPaymentLink":
          handleSendPaymentLink(extraParams?.payment_gateway);
      }
      return;
    } else {
      setFormErr(errors);
      extraParams?.isRecursive ? dynamicFormScrollBottom() : dynamicFormScroll();
    }
    return errors;
  };

  const handleNext = async (
    status_to_update,
    auto_fill_trigger,
    autofill,
    triggerPaymentCreation,
    amount
  ) => {
    if (!saveData?.length) {
      let activeSection = parseInt(blockSection);
      let activeGroup = parseInt(blockGroup);
      if (activeSection === 1 && activeGroup === 1) {
        dispatch(changeActiveSection(1));
        dispatch(changeActiveGroup(2));
      } else {
        dispatch(changeActiveSection(activeSection + 1));
        dispatch(changeActiveGroup(activeGroup + 1));
      }

      return;
    }

    let formattedData = { ...selectedData, last_login_at: new Date() };
    if (IndirectEval(auto_fill_trigger)) {
      let data = autoFillData(autofill, selectedData);
      if (data) {
        formattedData = { ...formattedData, ...data };
      }
    }
    let selectedSection = stepperSections[activeSection];
    let selectedGroup = selectedSection?.form_groups?.find(
      (item) => item.group_order == activeGroup
    );
    let nextStep = null;

    formattedData.active_section = activeSection;
    formattedData.active_group = nextStep;

    if (nextStep === null) {
      let nextMainStep = selectedSection?.section_order + 1;
      let nextSubStep = 1;
      formattedData.active_section = nextMainStep;
      formattedData.active_group = nextSubStep;
    }

    if (formattedData.active_section > maxActiveSection) {
      formattedData.max_active_section = formattedData.active_section;
      formattedData.max_active_group = formattedData.active_group;
    } else if (activeSection == maxActiveSection) {
      if (formattedData.active_group > maxActiveGroup) {
        formattedData.max_active_group = formattedData.active_group;
        formattedData.max_active_section = formattedData.active_section;
      }
    } else {
      formattedData.max_active_section = maxActiveSection;
      formattedData.max_active_group = maxActiveGroup;
    }

    let payload;
    if (saveData?.length) {
      let signer_data = [];
      let isRecursiveData = "true";
      let recursiveData = {};
      recursiveData[arrayName] = saveData;
      if (
        isSignerRecursion &&
        recursive &&
        recursive.signerParams &&
        recursive.signerParams.signer_validation_name
      ) {
        signer_data = [
          ...recursive.signerParams.signer_validation_name,
          arrayName,
        ];
      }
      dispatch(clearSaveData());
      dispatch(clearShowData());
      payload = createUserWorkflowPayload(
        formattedData,
        recursiveData,
        uploadedDocument,
        selectedQuestion,
        questionData,
        questionnaireId,
        isSignerRecursion,
        signer_data,
        documents,
        deleteDocument,
        evaluationRule,
        isRecursiveData
      );
    } else if (savedFormData) {
      let recursiveData = {};
      recursiveData[fieldRecursiveName] = savedFormData;
      payload = createUserWorkflowPayload(
        formattedData,
        recursiveData,
        uploadedDocument,
        selectedQuestion,
        questionData,
        questionnaireId,
        isSignerRecursion,
        saveData,
        documents,
        deleteDocument,
        evaluationRule
      );
    } else {
      payload = createUserWorkflowPayload(
        formattedData,
        null,
        uploadedDocument,
        selectedQuestion,
        questionData,
        questionnaireId,
        null,
        null,
        documents,
        deleteDocument,
        evaluationRule
      );
    }

    if (payload) {
      let formattedpayload = {
        ...payload,
        userId: decryptedId?.userId,
      };
      let statusUpadte = {
        status: status_to_update,
        applicant_id: decryptedId?.userId,
      };

      if (status_to_update && !loggedUserId) {
        dispatch(updateApplicantStatusAndSubWorkflowStatus(statusUpadte));
      }
      dispatch(updateWorkflowInfo(formattedpayload));

      //* Reseting Recursive states to default
      dispatch(setIsSignerRecursion(false));
      dispatch(setIsToggled(false));
      dispatch(setShowDataPreview(false));
      dispatch(clearSaveData());
      dispatch(clearShowData());
      dispatch(clearFieldRecursionData());
      dispatch(clearValidateTriggered());
      dispatch(cleardeleteDocument());
      dispatch(clearSignerParams());
    }
  };

  const calculateAmount = (paymentInfo) => {
    return paymentInfo?.user_data?.max_amount !== undefined
      ? Number(paymentInfo?.user_data?.max_amount)
      : Number(paymentInfo?.pending_amount);
  };

  const updateDataWithUploadedDocument = (data, uploadedDocument) => {
    for (const key in data) {
      if (typeof data[key] === "object" && data[key]?.encrypted_filename) {
        if (Object.keys(uploadedDocument).length) {
          if (uploadedDocument[data[key] || data[key]?.encrypted_filename]) {
            data[key] = uploadedDocument[data[key]?.encrypted_filename];
          }
        }
      }
    }
    return data;
  };

  const createPaymentDetails = (item, paymentDetails, selectedData) => {
    return {
      ...paymentDetails,
      payment_status: "success",
      payment_type: selectedData?.payment_type,
      payment_mode: selectedData?.payment_mode,
      amount: Number(item?.payment_amount),
    };
  };

  const handlePaymentResult = async (
    result,
    stateData,
    urlParams,
    navigationPath
  ) => {
    const encryptedParams = await encryptURLParams(urlParams);

    sessionStorage.setItem("stateData", JSON.stringify(stateData));

    const dynamicUrlParams = Object.keys(encryptedParams)
      .map((key) => encryptedParams[key])
      .filter((value) => value)
      .join("/");

    const dynamicUrl = `${navigationPath}/${dynamicUrlParams}`;

    navigate(dynamicUrl);
  };

  const handleOfflinePartialPayment = async () => {
    const userToken = localStorage.getItem("userToken");

    const offlinePartialRecursiveData = (saveData || [])
      .filter((item) => !item.transaction_id)
      .map((item) => ({
        ...updateDataWithUploadedDocument(item, uploadedDocument),
        amount: Number(item?.payment_amount),
        payment_status: "success",
        payment_type: selectedData?.payment_type,
        payment_mode: selectedData?.payment_mode,
        payment_details: createPaymentDetails(
          item,
          paymentDetails,
          selectedData
        ),
        userId: decryptedId?.userId,
        organisation_id: organisation_id,
        is_paid_by_internal_user: !!(
          userToken && Object.keys(JSON.parse(userToken))?.length
        ),
        paid_by_user_id:
          userToken &&
          Object.keys(JSON.parse(userToken))?.length &&
          JSON.parse(userToken)?.userId,
          paid_for_user_id : decryptedId?.userId
      }));

    const hasNoPendingAmount = await verifyPaymentStatusAndProceed();

    if (hasNoPendingAmount) return;
      setPaymentProcessingNotice(true)
    setIsUpdatingPayment(true);

    const result = await dispatch(
      updateOfflineMicroServicePartialPayment(offlinePartialRecursiveData)
    ).unwrap();

    setIsUpdatingPayment(false);
    setPaymentProcessingNotice(false)

    const stateData = {
      header: result ? "Payment Successfulll" : "Payment Failed",
      content: result
        ? "Your payment has been done successfully"
        : "Your payment has been failed",
      buttonText: "Done",
      organisation_id: organisation_id,
      isPaymentSuccess: result,
    };

    const urlParams = {
      encryptedUserID: decryptedId?.userId,
      encryptedPaymentTransactionId: decryptedId?.paymentTransactionId,
    };

    await handlePaymentResult(result, stateData, urlParams, "/payment-success");
  };

  const handleUpdatePartialPaymentViaRequestChanges = async () => {
    try {
      if (!transaction_id) return;

      const offlinePartialRecursiveData = (saveData || []).find(
        (item) => !item?.transaction_id
      );

      let matchedTransactionInPartialOffline =
        paymentDetails?.user_data?.offline_partial_payment?.find(
          (item) => item?.transaction_id == transaction_id
        );

      if (offlinePartialRecursiveData && matchedTransactionInPartialOffline) {
        matchedTransactionInPartialOffline = {
          ...matchedTransactionInPartialOffline,
          ...offlinePartialRecursiveData,
        };
      }

      const payload = {
        newData: matchedTransactionInPartialOffline,
        transactionId: transaction_id,
        userId: decryptedId?.userId,
        _id: paymentDetails?._id,
      // identifier to tract who is doing the payment which was careted for the user <decryptedId?.userId>

        identifier
      };
      setPaymentProcessingNotice(true)
      setIsUpdatingPayment(true);

      const result = await dispatch(
        updatePartialPaymentDataThroughRequestchange(payload)
      ).unwrap();

      if (result) {
        const stateData = {
          header: "Payment updation Successfulll",
          content: "Your payment has been updated successfully",
          buttonText: "Done",
          organisation_id: organisation_id,
          isPaymentSuccess: result,
        };

        const urlParams = {
          encryptedUserID: decryptedId?.userId,
          encryptedPaymentTransactionId: decryptedId?.paymentTransactionId,
        };

        await handlePaymentResult(
          result,
          stateData,
          urlParams,
          "/payment-success"
        );
      }
    } catch (error) {
      console.error(error);
    }
  };

  const handleUpdateFullPaymentViaRequestChanges = async () => {
    let offlineFullDataUpdated = { ...selectedData };
    Object.keys(offlineFullDataUpdated).forEach((item) => {
      if (offlineFullDataUpdated[item]?.encrypted_filename) {
        offlineFullDataUpdated[item] = uploadedDocument[item];
      }
    });
    offlineFullDataUpdated = {
      ...offlineFullDataUpdated,
    };

    const payload = {
      newData: offlineFullDataUpdated,
      transactionId: transaction_id,
      userId: decryptedId?.userId,
      _id: paymentDetails?._id,
      // identifier to track who is doing the payment which was careted for the user <decryptedId?.userId>
      identifier
    };

    setIsUpdatingPayment(true);
    setPaymentProcessingNotice(false)
    
    const result = await dispatch(
      updateFullPaymentDataThroughRequestchange(payload)
    ).unwrap();

    if (result) {
      const stateData = {
        header: "Payment updation Successfulll",
        content: "Your payment has been updated successfully",
        buttonText: "Done",
        organisation_id: organisation_id,
        isPaymentSuccess: result,
      };

      const urlParams = {
        encryptedUserID: decryptedId?.userId,
        encryptedPaymentTransactionId: decryptedId?.paymentTransactionId,
      };

      await handlePaymentResult(
        result,
        stateData,
        urlParams,
        "/payment-success"
      );
    }

  };

  const handleOfflinePayment = async (
    formattedData,
    selectedData,
    status_to_update
  ) => {
    const amount = calculateAmount(paymentInfo);
    const userToken = localStorage.getItem("userToken");

    if (eval(disablePartial)) {
      formattedData.payment_type = eval(disablePartial)
        ? "full"
        : selectedData?.payment_type?.toLowerCase();
    }

    const data = {
      ...formattedData,
      paymentTransactionId: decryptedId?.paymentTransactionId,
      userId: decryptedId?.userId,
      organisation_id: paymentDetails?.organisation_id,
      amount,
      payment_details: {
        ...paymentDetails,
        payment_status: "success",
      },
      offline_full_payment: {
        ...formattedData,
        amount,
      },
      is_paid_by_internal_user: !!(
        userToken && Object.keys(JSON.parse(userToken))?.length
      ),
      paid_by_user_id:
        userToken &&
        Object.keys(JSON.parse(userToken))?.length &&
        JSON.parse(userToken)?.userId,
        paid_for_user_id : decryptedId?.userId

    };

    if (eval(disablePartial)) {
      data.offline_full_payment.payment_type = eval(disablePartial)
        ? "full"
        : selectedData?.payment_type?.toLowerCase();
    }

    if (data?.internalUserInfo && Object.keys(data?.internalUserInfo)?.length) {
      data.internalUserInfo = {};
    }

   const hasNoPendingAmount = await verifyPaymentStatusAndProceed();

   if (hasNoPendingAmount) return;

   setPaymentProcessingNotice(true);
    setIsUpdatingPayment(true);

    const result = await dispatch(
      updateOfflineMicroServiceFullPayment(data)
    ).unwrap();
    setIsUpdatingPayment(false);
    setPaymentProcessingNotice(false)
    const stateData = {
      header: result ? "Payment Successfulll" : "Payment Failed",
      content: result
        ? "Your payment has been done successfully"
        : "Your payment has been failed",
      buttonText: "Done",
      organisation_id: organisation_id,
      isPaymentSuccess: result,
    };

    const urlParams = {
      encryptedUserID: decryptedId?.userId,
      encryptedPaymentTransactionId: decryptedId?.paymentTransactionId,
    };

    await handlePaymentResult(result, stateData, urlParams, "/payment-success");
  };

  const verifyPaymentStatusAndProceed = async (
    skipTransactionCheck = false
  ) => {
    const { paymentTransactionId: paymentId, userId } = decryptedId || {};

    const currentPaymentInfo = await dispatch(
      getPaymentAndUserInfo({ payment_id: paymentId, user_id: userId })
    ).unwrap();

    const hasNoPendingAmount =
      currentPaymentInfo.hasOwnProperty("pending_amount") &&
      Number(currentPaymentInfo?.pending_amount) === 0;

    if (hasNoPendingAmount && (skipTransactionCheck || !transaction_id)) {
      setIsUpdatingPayment(true);
      const stateData = {
        header: config?.payment_completed_header || "Payment Completed",
        content:
          config?.payment_completed_content ||
          "You do not have any pending amount to pay. As you've already paid the amount.",
        buttonText: config?.payment_completed_button_text || "Done",
        organisation_id: organisation_id,
        isPaymentSuccess: true,
      };

      const urlParams = {
        encryptedUserID: userId,
        encryptedPaymentTransactionId: paymentId,
      };

      await handlePaymentResult(true, stateData, urlParams, "/payment-success");

      setIsUpdatingPayment(false);
      return true;
    }
    return false;
  };

  const handleSendPaymentLink = (requestChangeConfig) => {
    setShowSendPaymentLinkModal(true);
    setRequestChangeConfig(requestChangeConfig);
  };

  const clearFieldError = (fields, isList) => {
    fields = isList ? fields : [fields];
    let err = { ...stateErrRef?.current };

    for (let key in fields) {
      const _field = fields[key];
      if (err[_field] !== undefined) {
        delete err[_field];
      }
    }
    setFormErr(err);
  };

  const handleRestrictedView = (item) => {
    if (item.restricted_view) {
      subWorkflow?.map((_item) => {
        if (decryptedId?.userId == _item?._id) {
          dispatch(setRestrictedView(decryptedId?.userId != _item?.user_id));
        }
      });
    }
  };

  const getActiveElement = (item) => {
    return stepperSections[activeSection]?.form_groups.findIndex(
      (group) => group.group_order == activeGroup
    );
  };

  /**
   * Renders a form element based on its type.
   * @param {Object} element - The form element to be rendered.
   * @param {Object} item - The item object containing the form groups.
   * @param {number} activeElement - The index of the active form group.
   * @param {number} index - The index of the current form element.
   * @returns {JSX.Element} - The rendered form element.
   */
  const rendrElement = (element, item, activeElement, index) => {
    const key = `${item?.form_groups?.[activeElement]?.group_order}-${
      element.name
    }-${index + 1}`;
    const commonProps = {
      key,
      formErr,
      clearFieldError,
      selectedData,
      setSelectedData,
      setFormErr,
    };

    if (element.type === "paymentRecursive") {
      const additionalProps = {
        ...commonProps,
        recursiveTrigger: element?.recursive_trigger,
        recursiveName: element?.recursive_name,
        inputFields: element?.input_fields,
        handleNext: validateAndSubmit,
        handleAdd: handleAdd,
        // handleSkip: handleSkip,
        handleCancel: handleCancel,
        selectedData: recursiveFormData,
        setSelectedData: setRecursiveFormData,
        recursiveActions: element?.recursive_actions,
        dataPreview,
        recursiveRead: element?.read,
        recursiveTitle: element?.title,
        minLength: element?.min_length,
        maxLength: element?.max_length,
      };

      return <PaymentRecursive key={key} {...additionalProps} {...element} />;
    }

    if (element.type === "group") {
      const additionalProps = {
        ...commonProps,
        formFields: element?.input_fields,

        handleNext: validateAndSubmit,
        handleAdd: handleAdd,
        // handleSkip: handleSkip,
        handleCancel: handleCancel,
        handleBack: handleBack,
        name: element?.name,
      };

      return (
        <Group
          key={key}
          {...additionalProps}
          formFields={element?.input_fields}
        />
      );
    }

    return <DynamicForm key={key} {...commonProps} formFields={element} />;
  };

  const closeSendPaymentLinkModal = () => {
    setShowSendPaymentLinkModal(false);
    setRequestChangeConfig({});
  };

  const sendPaymentLink = async (validEmails) => {
    const payload = {
      userId: decryptedId?.userId,
      transactionId: decryptedId?.paymentTransactionId,
      organisation_id: organisation_id,
      emailList: validEmails,
      amount:
        selectedData?.payment_type?.toLowerCase() == "full"
          ? paymentDetails?.pending_amount &&
            parseFloat(paymentDetails?.pending_amount)
          : selectedData?.partial_amount &&
            parseFloat(selectedData?.partial_amount),
      payment_mode: selectedData?.payment_mode,
      payment_type: selectedData?.payment_type,
      payment_details: paymentDetails,
      payment_status: requestChangeConfig?.status,
    };

    const result = await dispatch(
      sendPaymentLinkThroughMails(payload)
    ).unwrap();
    const stateData = {
      header: result
        ? requestChangeConfig?.success?.header
        : requestChangeConfig?.failure?.header,
      content: result
        ? requestChangeConfig?.success?.content
        : requestChangeConfig?.failure?.content,
      buttonText: result
        ? requestChangeConfig?.success?.buttonLabel
        : requestChangeConfig?.failure?.buttonLabel,
      organisation_id: organisation_id,
      isPaymentSuccess: result,
    };

    const urlParams = {
      encryptedUserID: decryptedId?.userId,
      encryptedPaymentTransactionId: decryptedId?.paymentTransactionId,
    };

    await handlePaymentResult(result, stateData, urlParams, "/payment-success");
    setSendingPaymentLink(false);
  };

  if (
    paymentLoader ||
    !paymentDetails ||
    !Object.keys(paymentDetails)?.length ||
    isUpdatingPayment ||
    configLoader ||
    isOnlinePaymentInitiated
  )
    return (
      <LoadingSpinner
        paymentLoadingText={
          (isOnlinePaymentInitiated && config?.loading_text) ||
          (showPaymentProcessingNotice && config?.offline_loading_text)
        }
      />
    );
  let subWorkflow = primaryUser?.source_data?.subworkflows;
  return (
    <Layout
      nav_orientation={formStructure?.nav_orientation}
      selectedData={selectedData}
      formErr={formErr}
      setFormErr={setFormErr}
      config={config}
      key={blockSection}
      landing={true}
      organisation={organisation_id}
    >
      {showSendPaymentLinkModal && (
        <SendPaymentLinkModal
          showSendPaymentLinkModal={showSendPaymentLinkModal}
          setShowSendPaymentLinkModal={setShowSendPaymentLinkModal}
          requestChangeConfig={requestChangeConfig}
          show={showSendPaymentLinkModal}
          onHide={closeSendPaymentLinkModal}
          sendPaymentLink={sendPaymentLink}
          setSendingPaymentLink={setSendingPaymentLink}
          sendingPaymentLink={sendingPaymentLink}
        />
      )}
      {Object.entries(stepperSections)?.map((item, index) => {
        item = item[1];
        const { section_order, display_section } = item;
        if (section_order === activeSection && IndirectEval(display_section)) {
          handleRestrictedView(item);

          let activeElement = getActiveElement(item);
          if (IndirectEval(item.form_groups[activeElement]?.show)) {
            fields = item.form_groups[activeElement].form_elements;

            return (
              <>
                {fields?.map((element, _index) =>
                  rendrElement(element, item, activeElement, _index)
                )}
                <FormButton
                  formButtons={item.form_groups[activeElement]?.form_buttons}
                  handleNext={validateAndSubmit}
                  handleSubmitApplication={validateAndSubmit}
                  handleCancel={handleCancel}
                  selectedData={selectedData}
                  isMobile={isMobile}
                  handleSubmitRequestedChanges={validateAndSubmit}
                  handlePayment={validateAndSubmit}
                  handleOfflinePayment={validateAndSubmit}
                  handleOfflinePartialPayment={validateAndSubmit}
                  handleBack={handleBack}
                  handleUpdatePartialPaymentViaRequestChanges={
                    validateAndSubmit
                  }
                  handleUpdateFullPaymentViaRequestChanges={validateAndSubmit}
                  handleSendPaymentLink={validateAndSubmit}
                />
              </>
            );
          }
        }
      })}
    </Layout>
  );
};

export default Payment;
